import { render } from "./KeikakumeisaiFoldableSubCostItem.vue?vue&type=template&id=564d1180"
import script from "./KeikakumeisaiFoldableSubCostItem.vue?vue&type=script&lang=js"
export * from "./KeikakumeisaiFoldableSubCostItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__